import { Checkbox, CheckboxProps } from '@components-deprecated'

import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Navigator = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: ${Spacing.S8};

  li {
    display: flex;
    align-items: center;

    + li {
      margin-left: ${Spacing.S24};
    }
  }
`

export const NavigationItem = styled.li``

export const FilterCheckbox = styled(Checkbox)<CheckboxProps>`
  margin: 0;

  label {
    margin-bottom: 0;
    color: ${Color.Black};
  }
`

export const SectionMessageWrapper = styled.div`
  margin-bottom: ${Spacing.S16};
`

export const WarningList = styled.ul`
  list-style-type: disc;
`

export const WarningListItem = styled.li`
  margin-left: ${Spacing.S16};
`
